import React from 'react'
import './FloatingIcons.css'
import whatsapp from '../../media/whatsapp.svg'
import phone from '../../media/phone.svg'
import { phoneNumbers } from '../../data/phoneNumbers';
const FloatingIcons = () => {
    return (
        <div className='floating-icons'>
            <a href={`https://wa.me/+2${phoneNumbers[0]}`} target="_blank" rel="noopener noreferrer" className='floating-icon' aria-label="تواصل معنا عبر واتساب">
                <img src={whatsapp} alt="واتساب" width={28} height={28} />
            </a>
            <a href={`tel:${phoneNumbers[0]}`} className='floating-icon phone' aria-label="اتصل بنا">
                <img src={phone} alt="اتصال هاتفي" width={28} height={28} />
            </a>
        </div>
    )
}

export default FloatingIcons

